import { render } from "./InputParagrafo.vue?vue&type=template&id=2ef9651e"
import script from "./InputParagrafo.vue?vue&type=script&lang=js"
export * from "./InputParagrafo.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/InputParagrafo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ef9651e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ef9651e', __exports__)) {
    console.log('reload')
    api.reload('2ef9651e', __exports__)
  }
  
  module.hot.accept("./InputParagrafo.vue?vue&type=template&id=2ef9651e", () => {
    console.log('re-render')
    api.rerender('2ef9651e', render)
  })

}


export default __exports__